import React from 'react';
import AutoCompleteField from './AutoCompleteField';

class AutoCompleteCityField extends AutoCompleteField {
  autoCompleteOptionType = [
    '(regions)'
  ];
}

export default React.forwardRef((props, ref)=> <AutoCompleteCityField innerRef={ref} {...props} />)